var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a10.002 10.002 0 01-9.173-6.014c-.208-.478.163-.986.685-.986.321 0 .607.2.739.494a8.5 8.5 0 100-6.988.82.82 0 01-.74.494c-.521 0-.892-.508-.684-.986A10.002 10.002 0 0112 2z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47 8.47a.75.75 0 011.06 0l2.824 2.823.068.076a1 1 0 010 1.262l-.069.076-2.823 2.823-.056.052a.75.75 0 01-1.056-1.056l.052-.056 1.72-1.72H3.5a.75.75 0 010-1.5h7.69L9.47 9.53a.75.75 0 010-1.06z",
    fill: "currentColor"
  })));
}
SvgLogIn.displayName = 'LogIn';
export default SvgLogIn;